import { notificationTypes } from '../constants'
import ContradictoryFactsDetail from './ContradictoryFactsDetail'
import PublishDelayDetail from './PublishDelayDetail'
import LowUpdateFrequencyDetail from './LowUpdateFrequencyDetail'
import RoomsWithoutImagesDetail from './RoomsWithoutImagesDetail'
import LowResolutionImagesDetail from './LowResolutionImagesDetail'

// map of detail-view renderers keyed by notification type. types without an
// entry have no detail view (clicking the row just marks it read). adding a new
// detail is additive: add a component and register it here.
export const notificationDetailRenderers = {
  [notificationTypes.CONTRADICTORY_FACTS]: ContradictoryFactsDetail,
  [notificationTypes.PUBLISH_DELAY]: PublishDelayDetail,
  [notificationTypes.LOW_UPDATE_FREQUENCY]: LowUpdateFrequencyDetail,
  [notificationTypes.ROOMS_WITHOUT_IMAGES]: RoomsWithoutImagesDetail,
  [notificationTypes.LOW_RESOLUTION_IMAGES]: LowResolutionImagesDetail,
}

export const hasNotificationDetail = (type) => Boolean(notificationDetailRenderers[type])
